import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { SelectBasketOffer } from 'app/shared/models/class/basket/basketList';
import { Counter, SelectCounterSessionBasketOffer } from 'app/shared/models/class/counter/counter';
import { FullOffer } from 'app/shared/models/class/offer/offer';
import { SessionBasketTraineeQuantity } from 'app/shared/models/class/session-basket/session-basket';
import { OfferSession } from 'app/shared/models/class/session/session';
import { Trainee } from 'app/shared/models/class/trainee/trainee';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { CounterService } from 'app/shared/services/counter/counter.service';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { SessionBasketService } from 'app/shared/services/session-basket/session-basket.service';
import { TraineeService } from 'app/shared/services/trainee/trainee.service';
import { OpendialogAddEditTraineeComponent } from '../../open-dialog-add-edit-trainee/opendialog-add-edit-trainee.component';
import { OpenDialogHelpComponent } from '../../open-dialog-help/open-dialog-help.component';
import { OpendialogCustomizeMySessionComponent } from '../opendialog-customize-my-session.component';

interface DialogData {
  offer: FullOffer;
  quantity: number;
  showError: boolean;
  userKey: number;
  counterSessionBasketKey: number;
  sessionKey: number;
}

@Component({
  selector: 'app-form-trainees-mobile',
  templateUrl: './form-trainees-mobile.component.html',
  styleUrls: ['./form-trainees-mobile.component.scss']
})
export class FormTraineesMobileComponent implements OnInit {
  @Input() data: DialogData;
  @Output() traineeActiveUpdate = new EventEmitter<Trainee[]>();

  userConnected: any;
  userKey: number;
  sessionSelected: OfferSession;
  trainees: Trainee[];
  traineesSelected: Trainee[];
  limitQuantity: number;
  color: ThemePalette = 'primary';

  canCloseDialog = true;

  constructor(
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<OpendialogCustomizeMySessionComponent>,
    private authService: AuthService,
    private traineeService: TraineeService,
    private sessionBasketService: SessionBasketService,
    private counterService: CounterService,
    private faIconService: FaiconService,

  ) { }

  ngOnInit(): void {
    this.initComponent();
    this.sessionsFiltered();
    this.getTrainees();
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  openDialogAddOrEditTrainee(action: string, trainee?: Trainee) {
    const dialogRef = this.dialog.open(OpendialogAddEditTraineeComponent, {
      data: { action, trainee, userKey: this.userKey, sessionKey: this.data.sessionKey },
      minWidth: '50%',
      height: '80%'
    });

    dialogRef.afterClosed().subscribe({
      next: (res) => {
        if (res) {
          const { counterSessionBasketKey, offer: { sessionBasketKey }, userKey } = this.data;
          const checkSession = new SelectBasketOffer(this.userKey, sessionBasketKey);
          this.sessionBasketService.checkSessionBasketComplete(checkSession).subscribe(() => {
            this.getTraineesAfterUpdate();
          });
        }
      }
    });
  }

  addOrDeleteTrainee(event, trainee: Trainee, indexTrainee: number) {
    const index = this.traineesSelected.findIndex(t => t.traineeKey === trainee.traineeKey);
    index === -1 ? this.traineesSelected.push(trainee) : this.traineesSelected.splice(index, 1);

    this.updateSessionBasketTrainees();
  }

  private updateSessionBasketTrainees() {
    const trainees = this.traineesSelected.map(trainee => trainee.traineeKey).join(';') || '';

    const { counterSessionBasketKey, offer: { sessionBasketKey }, userKey } = this.data;
    if (!counterSessionBasketKey || counterSessionBasketKey === undefined) {

      this.sessionBasketService.UpdateSessionBasketTrainees(sessionBasketKey, trainees).subscribe({
        next: () => {
          const checkSession = new SelectBasketOffer(this.userKey, sessionBasketKey);
          const updateSession = new SessionBasketTraineeQuantity(sessionBasketKey, this.userKey, this.traineesSelected.length);
          this.sessionBasketService.UpdateQuantityBasketOffer(updateSession).subscribe(() => {
            this.sessionBasketService.checkSessionBasketComplete(checkSession).subscribe(() => {
              this.getTraineesAfterUpdate();
            });
          });
          this.traineeActiveUpdate.emit(this.traineesSelected);
        }
      });
    } else {

      this.counterService.updateSessionBasketTrainees(counterSessionBasketKey, trainees).subscribe({
        next: () => {
          const checkSession = new SelectCounterSessionBasketOffer(counterSessionBasketKey, this.userConnected.sub, userKey, true);
          const updateSession = new Counter(counterSessionBasketKey, this.userConnected.sub, userKey, this.traineesSelected.length);
          this.counterService.updateCounterTraineeQuantity(updateSession).subscribe(() => {
            this.counterService.checkCounterSessionBasketComplete(checkSession).subscribe(() => {
              this.getTraineesAfterUpdate();
            });
          });
          this.traineeActiveUpdate.emit(this.traineesSelected);
        }
      });
    }

  }

  private sessionsFiltered(): void {
    const { offer: { sessions, quantity } } = this.data;
    const check: OfferSession[] = sessions?.filter(session => (session.quantity - session.bookedSessionTrainees) >= quantity);
  }

  private getTrainees(): void {
    this.traineeService.getTraineesBySession(this.userKey, this.data.sessionKey).subscribe({
      next: trainees => {
        this.trainees = trainees;

        const { offer: { trainees: traineesData } } = this.data;

        for (const trainee of this.trainees) {
          if (traineesData?.length) {
            const index = traineesData?.findIndex(t => t.traineeKey === trainee.traineeKey);
            trainee.checked = index === -1 ? false : true;
          }
        }

        this.canCloseDialog = true;

        this.trainees.map((trainee, indexAll) => {
          trainee.hasParamsToSet = false;
          if (trainee?.parameters?.length > 0) {
            let params = trainee.parameters;
            params.map(oneParam => {
              if (!oneParam.selectedValue) {
                trainee.hasParamsToSet = true;;
                this.canCloseDialog = false;
              }
            })
          } else {
            trainee.hasParamsToSet = false;
          }


        })

        this.traineesSelected = this.trainees.filter(t => t.checked);


      }

    });
  }

  getTraineesAfterUpdate() {
    this.traineeService.getTraineesBySession(this.userKey, this.data.sessionKey).subscribe({
      next: trainees => {
        trainees.map(oneTrainee => {
          let hasFound = false;
          let hasFoundAll = false;
          this.traineesSelected.map((traineeSelected, index) => {
            if (traineeSelected.traineeKey === oneTrainee.traineeKey) {
              hasFound = true;
              this.traineesSelected[index] = oneTrainee;

              this.trainees.map((trainee, indexAll) => {
                if (trainee.traineeKey === traineeSelected.traineeKey) {
                  this.trainees[indexAll] = oneTrainee;
                  this.trainees[indexAll].checked = true;
                }
              })
            }
          })

          if (!hasFound) {
            this.trainees.map((trainee, index) => {
              if (trainee.traineeKey === oneTrainee.traineeKey) {
                this.trainees[index] = oneTrainee;
                hasFound = true;
                hasFoundAll = true;
              }
            })
          }

          if (!hasFound && !hasFoundAll) {
            this.trainees.push(oneTrainee);
          }
        })
        this.checkIfErrorParams();
      }
    });
  }

  private initComponent(): void {
    this.userConnected = this.authService.getDecodedToken();
    this.userKey = this.data.userKey;
    const { offer: { hasSession, sessions, sessionKey, trainees } } = this.data;

    if (hasSession) {
      this.sessionSelected = sessions?.find(el => el.sessionKey === sessionKey);
    }

    const checkSession: OfferSession[] = sessions?.filter(session => (session.quantity - session.bookedSessionTrainees) >= trainees?.length);
    const checkCopy = checkSession?.length ? [...checkSession] : [];
    this.limitQuantity = Math.max(...checkCopy.map(s => s.quantity - s.bookedSessionTrainees));
  }

  checkIfErrorParams() {
    this.canCloseDialog = true;

    this.traineesSelected.map(traineeSelected => {
      this.trainees.map((trainee, indexAll) => {
        if (trainee.traineeKey === traineeSelected.traineeKey) {
          if (traineeSelected?.parameters?.length > 0) {
            let params = traineeSelected.parameters;
            params.map(oneParam => {
              if (!oneParam.selectedValue) {
                trainee.hasParamsToSet = true;;
                this.canCloseDialog = false;
              }
            })
          } else {
            trainee.hasParamsToSet = false;
          }
        }


      })
    })
  }

  openDialogHelp() {
    this.dialog.open(OpenDialogHelpComponent, {
      data: { helpVideoKey: 2 },
      width: '60%',
      maxHeight: '90%'
    });
  }
}
